import { render, staticRenderFns } from "./Liability.vue?vue&type=template&id=087c50f2"
import script from "./Liability.vue?vue&type=script&lang=js"
export * from "./Liability.vue?vue&type=script&lang=js"
import style0 from "./Liability.vue?vue&type=style&index=0&id=087c50f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports